import React from 'react';
import './AddBusinessPage.css';
import CommonHeader from './CommonHeader';
import ProfileForm from './ProfileForm';

const AddBusinessPage: React.FC = () => {
  return (
    <div className="signup-container">
      <CommonHeader />

      <main className="signup-main">
        <ProfileForm />
      </main>
    </div>
  );
};

export default AddBusinessPage;